import React from 'react';

const ApprovalList = ({ approvals, checkedIds, selectAll, onToggle, onToggleAll }) => {

  if (!approvals) {
    return <p className="reports-table__empty">Loading approvals...</p>;
  }

  if (approvals.length === 0) {
    return <p className="approve__list-empty">No visitors to approve.</p>;
  }

  return (
    <div className="approve__list-wrap">
      <label className="approve__select-all">
        <input
          type="checkbox"
          checked={selectAll}
          onChange={onToggleAll}
        />
        Select All
      </label>
      <ul className="approve__visitor-list">
        {approvals.map((approval) => (
          <li key={approval.id} className="visit-submitted__person">
            <label className="approve__visitor-row">
              <input
                type="checkbox"
                checked={!!checkedIds[approval.id]}
                onChange={() => onToggle(approval.id)}
              />
              <span className="visit-submitted__person-name">
                {approval.first_name} {approval.last_name}
              </span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ApprovalList;
